import { OptionProps, components } from 'react-select';
import React from 'react';

export interface PCPOptionType {
    label: string;
    duplicate: boolean;
    clinicName: string;
}
export function PCPOption(props: OptionProps<PCPOptionType, true>) {
    return (
        <components.Option {...props}>
            {props.data.label}
            {props.data.duplicate ? (
                <span className="fst-italic text-secondary"> ({props.data.clinicName})</span>
            ) : null}
        </components.Option>
    );
}
